import React from 'react';
import proptypes from 'prop-types';
import { Tab, Tabs } from '@one-thd/sui-atomic-components';

const { string, arrayOf, shape, func, node, number } = proptypes;

export const TabContent = ({
  id, items, buildDrawer, selectedTab, onTabChange
}) => {

  function TabPanel(props) {
    const {
      children,
      value,
      index
    } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
      >
        {value === index && (
          <div className="sui-pt-6">
            <div>{children}</div>
          </div>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: node.isRequired,
    index: number.isRequired,
    value: number.isRequired
  };

  const handleTabChange = (tabId, newValue) => {
    onTabChange(tabId, newValue);
  };

  return (
    <div className="sui-w-full" key={id}>
      <Tabs
        value={selectedTab}
        onChange={(_event, newValue) => handleTabChange(id, newValue)}
        variant="fullWidth"
      >
        {items.map((tab, index) => (
          <Tab
            key={tab.id}
            label={tab.label}
            id={`simple-tab-${index}`}
            aria-controls={`simple-tabpanel-${index}`}
            data-testid={tab.id === 'tab_1' ? 'fit-compatibility-stacked-tab' : 'fit-compatibility-sbs-tab'}
          />
        ))}
      </Tabs>
      {items.map((tab, index) => (
        <TabPanel
          key={tab.id}
          value={selectedTab}
          index={index}
        >
          {buildDrawer(tab.content, index + 1)}
        </TabPanel>
      ))}
    </div>
  );
};

TabContent.propTypes = {
  id: string.isRequired,
  items: arrayOf(shape()).isRequired,
  buildDrawer: func.isRequired,
  selectedTab: number.isRequired,
  onTabChange: func.isRequired
};
